import { customAlphabet } from "nanoid";
import { z } from "zod";
function schemaModel(data, schema, throwError = true) {
  const result = schema.safeParse(data);
  if (!result.success) {
    console.error("Zod Schema Error");
    console.group();
    result.error.issues.forEach((issue) => {
      console.log(`Path: ${issue.path.join(", ")} 
Error: ${issue.message}`);
    });
    console.groupEnd();
  }
  if (throwError && !result.success) throw new Error("Zod validation failure");
  return result.success ? result.data : null;
}
const NANOID_ALPHABET = "useandom26T198340PX75pxJACKVERYMINDBUSHWOLFGQZbfghjklqvwyzrict";
const nanoid = (size) => {
  return customAlphabet(NANOID_ALPHABET, 21)(size);
};
const emailSchema = z.email().transform((a) => a.toLowerCase());
const timestampSchema = z.number().int().min(0);
const nanoidSchema = z.string().min(5);
const entitySchema = z.object({
  uid: nanoidSchema.default(nanoid),
  createdAt: timestampSchema.default(unixTimestamp),
  updatedAt: timestampSchema.default(unixTimestamp)
});
function unixTimestamp(date = Date.now()) {
  return Math.floor(new Date(date).getTime() / 1e3);
}
var Environments = /* @__PURE__ */ ((Environments2) => {
  Environments2["Dev"] = "development";
  Environments2["Test"] = "test";
  Environments2["Prod"] = "production";
  Environments2["Staging"] = "staging";
  return Environments2;
})(Environments || {});
const deployEnvironmentsSchema = z.enum(Environments).optional().default("development" /* Dev */);
const regexSemverNumberedGroups = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
const semverSchema = z.string().regex(regexSemverNumberedGroups, {
  message: "Version must be a valid semver format (e.g. 0.0.1)"
});
function arrayToMap(array) {
  return array.reduce((acc, item) => {
    acc[item.uid] = item;
    return acc;
  }, {});
}
const regexSlug = /^[a-z](?:[a-z0-9-]*[a-z0-9])?$/;
const slugSchema = z.string().min(1, "Slug is required").min(3, "Slug must be at least 3 characters").max(60, "Slug must be less than 60 characters").regex(regexSlug, {
  message: "Slug can have lowercase letters, digits, or hyphens. It must start with a lowercase letter and end with a letter or number."
});
const setPreprocess = (input) => input instanceof Set ? input : Array.isArray(input) ? new Set(input) : input;
const setTransform = (set) => Array.from(set);
const scalarSet = (zodSetType) => z.preprocess(setPreprocess, zodSetType).transform(setTransform);
const slugify = (v) => v.normalize("NFC").toLowerCase().trim().replace(/[^\p{L}\p{M}\p{N}\s-]/gu, "").replace(/[\s-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 255);
const originSchema = z.string().transform(
  (arg) => arg.split(",").map((s) => s.trim()).filter((s) => !!s).map((arg2) => {
    if (arg2.at(0) !== "^") return arg2;
    try {
      return new RegExp(arg2);
    } catch {
      return arg2;
    }
  })
);
const namespaceSchema = z.string().regex(
  /^[a-zA-Z0-9-_]+$/,
  'Namespaces can only contain letters, numbers, "-", and "_".'
).toLowerCase().min(3, "Namespaces need to be at least 3 characters.").max(50, "Namespaces need to be less than 50 characters.");
const objectSchema = z.record(
  z.union([z.string(), z.number(), z.symbol()]),
  z.any()
);
function zodInnerType(schema) {
  if (!(schema instanceof z.ZodPipe)) return schema;
  if (schema.out instanceof z.ZodObject) return schema.out;
  if (schema.in instanceof z.ZodObject) return schema.in;
  return schema.in;
}
class ErrorWithCtx extends Error {
  context = {};
  constructor(message, { context }) {
    super(message);
    this.name = "ErrorWithCtx";
    if (context) this.context = context;
  }
}
const registryMetaSchema = z.object({
  namespace: z.string(),
  slug: z.string()
});
export {
  Environments,
  ErrorWithCtx,
  NANOID_ALPHABET,
  arrayToMap,
  deployEnvironmentsSchema,
  emailSchema,
  entitySchema,
  namespaceSchema,
  nanoid,
  nanoidSchema,
  objectSchema,
  originSchema,
  regexSemverNumberedGroups,
  regexSlug,
  registryMetaSchema,
  scalarSet,
  schemaModel,
  semverSchema,
  slugSchema,
  slugify,
  timestampSchema,
  unixTimestamp,
  zodInnerType
};
//# sourceMappingURL=utility.js.map
